var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contactAs)?_c('div',{staticClass:"page-contact"},[_c('el-tooltip',{attrs:{"effect":"dark","content":"联系我们","placement":"left"}},[_c('a',{attrs:{"target":"_blank","href":`http://popo.netease.com/static/html/open_popo.html?ssid=${_vm.contactAs}&sstp=0`}},[_c('img',{staticClass:"pc-icon",attrs:{"src":"/img/popo.png"}})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }